<template>
  <div v-if="loading" >
    <div v-if="projects.length > 0" class="container pt-5 " >
      <section class="py-5" id="about">
        <div class="container text-center">
          <div class="row">
            <div class="col-lg-10 mx-auto">
              <h1>{{$t("m_main_title")}}</h1>
              <p class="lead">{{$t("m_main_subtitle")}}</p>
            </div>
          </div>
        </div>
      </section>
      <div class="row">
        <div v-for="project in projects" class="col-md-6 col-lg-4 mb-3">
          <div class="card" style="height: 100%">
            <img class="card-img-top" :src="project.image" alt="Card image cap">
            <div class="card-body d-flex flex-column">
              <h5 class="card-title ">{{ project.title }}</h5>
              <p class="card-text mb-0" v-if="getCurrentLang() == 'en'">{{project.tldr_en}}</p>
              <p class="card-text mb-0" v-else>{{project.tldr}}</p>
              <router-link :to="{ name: 'ProjectDetail', params: { id: project.id } }" class="btn mt-auto btn-primary">{{$t("m_button")}}</router-link>
            </div>
          </div>
        </div>
        
        
        <!-- <div v-for="project in projects" class="col-md-3 col-sm-12" >
          <div class="card col-md brick__inner" style="border-radius:10px; height:100%; margin-top:3px;">
            <img :src="project.image" alt="" class="img-fluid" style="border-radius:10px;" >
              <div class="card-body">
                <h5 class="card-title">{{ project.title }}</h5>
                <p class="card-text">{{ project.tldr }}</p>
                <router-link :to="{name: 'ProjectDetail', params: { id: project.id}}"><span class="align-bottom btn btn-primary">Vai al progetto</span></router-link>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div v-else class="container pt-5">
      <section class="py-5" id="about">
        <div class="container text-center">
          <div class="row">
            <div class="col-lg-10 mx-auto">
              <h1>Non ci sono progetti</h1>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-5" v-else>
    <div class="loader"></div>
  </div>
</template>

<script>
import { database, storage } from '@/firebase'

export default {
  name: "Projects",
  data() {
    return {
      projects: [],
      loading: false
    }
  },
  methods: {
    getCurrentLang: function() {
      var current_locale = "en"
      if (navigator.language.includes("it")){
        current_locale = "it"
      }      
      return current_locale
    }
  },
  created() {
    database.collection('Projects')
      .where('isPrivate', '==', false)
      .get().then(snap => {
        snap.forEach(doc => {
          let project = { ...doc.data()}
          project.id = doc.id

          project.team.get().then(teamDoc => {
            project.team = teamDoc.data()
          }).catch(err => {
            console.error(err)
          })

          storage.child("Projects/"+project.id+"/profilo").getDownloadURL().then(url => {
            project.image = url;
            this.projects.push(project)
            this.loading = true;
          })
          .catch(err => {
            project.image = 'https://placehold.it/500'
            this.projects.push(project)
            console.error(err)
          })
        })
      }).catch(err => {
        console.error(err)
      })
  }
};
</script>

<style scoped>
.card{
  width: 18rem; 
  padding:0px;
}
body {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: "Lato", sans-serif;
  letter-spacing: 0px;
  font-size: 16px;
  color: #62686c;
  font-weight: 400;
  line-height: 28px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 300;
  color: #11181f;
  margin: 0px 0px 15px 0px;
  font-family: "Lato", sans-serif;
}
h1 {
  font-size: 44px;
}
h2 {
  font-size: 38px;
}
h3 {
  font-size: 24px;
  font-weight: 400;
}
h4 {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
}
h5 {
  font-size: 16px;
  font-weight: 400;
}
h6 {
  font-size: 12px;
  font-weight: 400;
}
p {
  margin: 0 0 20px;
  line-height: 1.7;
}
p:last-child {
  margin: 0px;
}
a {
  text-decoration: none;
  color: #62686c;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

a:hover {
  text-decoration: none;
  color: #f67800;
}

.content {
  padding-top: 80px;
  padding-bottom: 80px;
}
.mb40 {
  margin-bottom: 40px;
}
.team-block {
  margin-bottom: 20px;
}
.team-content {
  position: absolute;
  background-color: rgba(17, 24, 31, 0.8);
  bottom: 0px;
  display: inline-block;
  width: 100%;
  color: #fff;
  padding: 30px;
}
.team-img {
  position: relative;
}
.team-img img {
  width: 100%;
}
.team-meta {
  color: #9da4aa;
  font-weight: 400;
  font-size: 16px;
}
.overlay {
  border-radius: 0px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #11181f;
}

.team-img:hover .overlay {
  opacity: 0.8;
}
.team-img:hover .team-content {
  opacity: 0;
}
.text {
  color: #fff;
  position: absolute;
  top: 30%;
  left: 30%;
  transform: translate(-26%, -26%);
  -ms-transform: translate(-26%, -26%);
  right: 0;
  font-weight: 400;
  font-size: 16px;
}
.text .btn.btn-outline-primary {
  color: white;
}
.imgcard{
  width: 100%;
  
}

.loader {
  border: 4px solid #f3f3f3;
  border-radius: 100%;
  border-top: 4px solid #46484c;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 0.5s linear infinite;
}

#div1{
  background-color: #1D809F;
}
/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue